import * as React from 'react';
import { observer } from 'mobx-react';
import { Heading5, Body1 } from 'elc-typography';
import { ContentSpacing } from 'elc-base-theme';
import styled from 'styled-components';
import { Row } from 'elc-grid';
import { classes } from '../../utils/Classes';

export interface IProductInfoPopupContent {
    dataToLoad: string;
    header: string;
}

const StyledRow = styled(Row)`
    display: flex;
    flex-direction: column;
    margin-bottom: ${ContentSpacing.space16};
`;

export const ProductInfoPopupContent = observer((props: IProductInfoPopupContent) => {
    const { dataToLoad, header } = props;

    const productInfoPopupContentWrapperClassNames = classes('product-info-popup-content-wrapper');
    const productInfoPopupContentClassNames = classes('product-info-popup-content');
    const productInfoPopupHeaderClassNames = classes('product-info-popup-header');

    return (
        <div className={productInfoPopupContentWrapperClassNames}>
            <StyledRow className={productInfoPopupContentClassNames}>
                {header && (
                    <Heading5
                        dangerouslySetInnerHTML={{ __html: header }}
                        className={productInfoPopupHeaderClassNames}
                    />
                )}
                <Body1 dangerouslySetInnerHTML={{ __html: dataToLoad }} />
            </StyledRow>
        </div>
    );
});
